export const PLACEHOLDER = "e.g. address, building, agent";
export const HIDDEN_LABEL = "Search";
export const VALIDATION_ERROR = "Please enter something to search for!";
